import { LISTAR_RAMAIS, SELECIONAR_RAMAL, LISTAR_TRONCOS, LISTAR_ROTAS, LISTAR_GRUPOS, LISTAR_GRUPOS_DE_ROTAS } from './mutation-types'

import RamaisHttpService from '../_services/RamaisHttpService'

export default {
  listarRamais: async ({ commit }) => {
    try {
      const response = await RamaisHttpService.getRamais()
      commit(LISTAR_RAMAIS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarTroncos: async ({ commit }) => {
    try {
      const response = await RamaisHttpService.getTroncos()
      commit(LISTAR_TRONCOS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarRotas: async ({ commit }) => {
    try {
      const response = await RamaisHttpService.getrotas()
      commit(LISTAR_ROTAS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  selecionarRamal: async ({ commit }, _id) => {
    try {
      const response = await RamaisHttpService.getRamal(_id)
      commit(SELECIONAR_RAMAL, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarGrupo: async ({ commit }) => {
    try {
      const response = await RamaisHttpService.getGrupos()
      commit(LISTAR_GRUPOS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarGruposDeRotas: async ({ commit }) => {
    try{
      const responde = await RamaisHttpService.getGruposDeRotas()
      commit(LISTAR_GRUPOS_DE_ROTAS, responde.data)
    } catch(e) {
      console.log(e)
    }
  },
}
